export const defaultFavouriteLabels = {
    favouriteActive: '',
    favouriteInactive: '',
    popupConfirm: '',
    close: '',
    favouriteslimitText: '',
    favouriteslimitTitle: '',
    favouriteErrorText: '',
    favouriteErrorTitle: '',
    favouriteRemoveError: '',
    checkoutOffersError: '',
};
//# sourceMappingURL=favouriteLabels.js.map